import React from "react";
var __jsx = React.createElement;
import { useRouter } from "next/router";
import Link from "next/link";
import useAdminPriveleges from "../hooks/useAdminPriveleges";
function AdminViewBtn(props) {
  var metabase_enabled = props.metabase_enabled;
  var router = useRouter();
  var hasAdminPrivileges = useAdminPriveleges();
  if (!hasAdminPrivileges) {
    return;
  }
  var hasDashboardAndWorklistButtons = metabase_enabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-gray-100 text-nowrap flex items-center ".concat(/admin/g.test(router.asPath) ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10", " transition duration-500 hover:bg-teal-500/10 px-4 ").concat(hasDashboardAndWorklistButtons ? "" : "ml-6")
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/admin"
  }, "Site Administration"));
}
export default AdminViewBtn;